import type { MinimalPlayerRatings } from "../../../common/types.ts";
import { helpers } from "../../util/index.ts";

export const simulatePlayerFuture = ({
	currentRatings,
	currentAge,
	maxAge,
	lockedValues,
	develop,
	afterDevelop,
	afterAge,
}: {
	currentRatings: MinimalPlayerRatings;
	currentAge: number;
	maxAge: number;
	lockedValues?: Record<number, MinimalPlayerRatings>;
	develop: (ratings: MinimalPlayerRatings, age: number) => void;
	afterDevelop?: (ratings: MinimalPlayerRatings) => void;
	afterAge?: (ratings: MinimalPlayerRatings) => void;
}) => {
	const copiedRatings = helpers.deepCopy(currentRatings);
	const future: Record<number, MinimalPlayerRatings> = {};

	for (let age = currentAge + 1; age <= maxAge; age++) {
		const locked = lockedValues?.[age];
		if (locked) {
			Object.assign(copiedRatings, helpers.deepCopy(locked));
		} else {
			develop(copiedRatings, age);
			afterDevelop?.(copiedRatings);
		}
		afterAge?.(copiedRatings);

		future[age] = helpers.deepCopy(copiedRatings);
	}

	return future;
};
